<template>
  <div>
    <HeadBar /><!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <Map @showList="showList" />
    <LabList :data="laboratory" />
    <FootBar class="footer" />
  </div>
</template>
<script>
import LabList from "./labList";
import Map from "./map";
import { nearByLabs } from "@/api/lab";
export default {
  components: { LabList, Map },
  data() {
    return {
      show: false,
      areaSerachKey: "",
      laboratory: null,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    showList(data) {
      this.laboratory = data;
    },
    async getList() {
      const res = await this.$axios.get(nearByLabs);
      this.laboratory = res.mapRespondList[0];
    },
  },
};
</script>
<style lang="scss" scoped></style>
